import localforage from "localforage";
import {decryptAES} from "./decryptAES";

export const generateInitialState = async (keyName = "", defaultState = {}) => {
  if (!keyName || !defaultState) {
    console.log("keyName and defaultState are required");
    return {};
  }

  const localForageKey = `offline:${keyName}`;

  const initialStateEncrypted = await localforage.getItem(localForageKey);
  if (!initialStateEncrypted && initialStateEncrypted === null) return defaultState;

  const initialStateDecrypted = decryptAES(initialStateEncrypted?.replace('"', ""));
  return initialStateDecrypted ? JSON.parse(initialStateDecrypted) : defaultState;
};
